export default __webpack_public_path__ + "static/media/russ.a4c6cee5.jpg";